import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import {injectIntl} from "react-intl";
import Select, {SelectOption} from "@amzn/meridian/select";
import Column from "@amzn/meridian/column";
import Button from "@amzn/meridian/button";
import Box from "@amzn/meridian/box";
import React from "react";
import {getLocalizedMessage} from "../../util/Localization";

const renderDeviceSelectionRow = (props) => {
    const {
        selectedMac, setSelectedMac, deviceList, setOpenTriggerValidationModal, intl
    } = props;
    return (
        <Box type="fill" spacingInset="medium">
            <Row alignmentHorizontal="justify" widths={["fill", '30%']} spacing="400">
                <Row>
                    <Text>
                        {getLocalizedMessage({intl, stringId: 'devicename.title'})}
                    </Text>
                    <Select
                        value={selectedMac}
                        onChange={setSelectedMac}
                        placeholder={getLocalizedMessage({intl, stringId: 'devicename.title'})}
                        size="small"
                        width={250}>
                        {deviceList.map((device) => (
                            <SelectOption key={device.mac} value={device.mac}
                                          label={device.name + " (" + device.mac + ")"}/>
                        ))}
                        {!deviceList.length &&
                            <Column alignmentVertical="center" spacing="100" spacingInset="100">
                                <Text alignment="center">{getLocalizedMessage({intl, stringId: 'modal.no_device_available'})}</Text>
                            </Column>
                        }
                    </Select>
                </Row>
                <Row alignmentHorizontal="end">
                    <Button
                        size="small"
                        disabled={!selectedMac}
                        onClick={() => setOpenTriggerValidationModal(true)}
                    >{getLocalizedMessage({intl, stringId: 'mhevalidation.newvalidation'})}
                    </Button>
                </Row>
            </Row>
        </Box>
    )
}

const MHEValidationTabHeader = (props) => {

    return (
        <Column>
            {renderDeviceSelectionRow({ ...props})}
        </Column>
    )
}

export default injectIntl(MHEValidationTabHeader)



// WEBPACK FOOTER //
// ./src/components/commonui/mheValidation/mheValidationTabHeader.js